import axios from "axios";
import {URL_BASE} from "@/configs/constants";

const RESOURCE = 'budget';
export default {

    loadBudgets(context, params) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.get(`${URL_BASE}${RESOURCE}`, {params})
                .then(response => {
                    context.commit('LOAD_BUDGET', response.data)
                    return resolve(response.data)
                }).catch(errors => {
                return reject(errors)
            })
                .finally(() => {
                    context.commit('LOADER', false)
                })
        })
    },

    storeBudget(context, formData) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}${RESOURCE}`, formData)
                .then((r) => resolve(r))
                .catch(errors => reject(errors))
                .finally(() => {
                    context.commit('LOADER', false)
                })
        })
    },

    loadBudget(context, id) {
        return new Promise((resolve, reject) => {
            axios.get(`${URL_BASE}${RESOURCE}/${id}`)
                .then(response => resolve(response.data))
                .catch((e) => reject(e))
        })
    },

    updateBudget(context, formData) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.put(`${URL_BASE}${RESOURCE}/${formData.id}`, formData)
                .then((r) => {
                    resolve(r)
                })
                .catch(errors => reject(errors))
                .finally(() => context.commit('LOADER', false))
        })
    },

    destroyBudget(context, id) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.delete(`${URL_BASE}${RESOURCE}/${id}`)
                .then((r) => {
                    resolve(r)
                })
                .catch(errors => reject(errors))
                .finally(() => context.commit('LOADER', false))
        })
    },

    storeBudgetObs(context, formData) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}budget-add-obs`, formData)
                .then((r) => resolve(r))
                .catch(errors => reject(errors))
                .finally(() => {
                    context.commit('LOADER', false)
                })
        })
    },

    // budgetSend(context, id) {
    //     context.commit('LOADER', true)
    //     return new Promise((resolve, reject) => {
    //         axios.put(`${URL_BASE}budget-send/${id}`)
    //             .then((r) => {
    //                 resolve(r)
    //             })
    //             .catch(errors => reject(errors))
    //             .finally(() => context.commit('LOADER', false))
    //     })
    // },
    //
    // budgetCancel(context, id) {
    //     context.commit('LOADER', true)
    //     return new Promise((resolve, reject) => {
    //         axios.put(`${URL_BASE}budget-cancel/${id}`)
    //             .then((r) => {
    //                 resolve(r)
    //             })
    //             .catch(errors => reject(errors))
    //             .finally(() => context.commit('LOADER', false))
    //     })
    // },
    //
    // budgetApproved(context, id) {
    //     context.commit('LOADER', true)
    //     return new Promise((resolve, reject) => {
    //         axios.put(`${URL_BASE}budget-approved/${id}`)
    //             .then((r) => {
    //                 resolve(r)
    //             })
    //             .catch(errors => reject(errors))
    //             .finally(() => context.commit('LOADER', false))
    //     })
    // },
    //
    // budgetEnd(context, id) {
    //     context.commit('LOADER', true)
    //     return new Promise((resolve, reject) => {
    //         axios.put(`${URL_BASE}budget-end/${id}`)
    //             .then((r) => {
    //                 resolve(r)
    //             })
    //             .catch(errors => reject(errors))
    //             .finally(() => context.commit('LOADER', false))
    //     })
    // },

    budgetUpdateStatus(context, formData) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.put(`${URL_BASE}budget-update-status/${formData.id}`, formData)
                .then((r) => {
                    resolve(r)
                })
                .catch(errors => reject(errors))
                .finally(() => context.commit('LOADER', false))
        })
    },

    storeBudgetGuarantee(context, formData) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}budget-add-guarantees`, formData)
                .then((response) => {
                    return resolve(response.data)
                }).catch((errors) => {
                return reject(errors)
            }).finally(() => context.commit('LOADER', false))
        })
    },

    updateBudgetGuarantee(context, formData) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.put(`${URL_BASE}budget-update-guarantees/${formData.id}`, formData)
                .then((response) => {
                    return resolve(response.data)
                }).catch((errors) => {
                return reject(errors)
            }).finally(() => context.commit('LOADER', false))
        })
    }
}
